import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('jobPackagesPallets', jobPackagesPallets);

function jobPackagesPallets($translate) {
  return function jobPackagesPalletsFilter(orderPackagesRef, enableSuffix?) {
    let sum = 0;

    if (orderPackagesRef) {
      sum = orderPackagesRef.reduce((acc, item) => {
        if (item?.pallets) {
          acc += item.pallets;
          // acc += (item.pallets * (item.count || 1));
        }
        return acc;
      }, 0);
    }
    let decimalNumber: number = Number.isSafeInteger(sum) ? 0 : 2;

    return enableSuffix ? $translate.instant(sum == 1 ? 'X_PALLET' : 'X_PALLETS', {sum: sum.toFixed(decimalNumber)}) : sum.toFixed(decimalNumber);
  }
}
